import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "18", cy: "18", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "6", cy: "6", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 21V9a9 9 0 0 0 9 9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "GitMerge";
const GitMerge = memo(themed(Icon));
export {
  GitMerge
};
//# sourceMappingURL=git-merge.js.map
